import { Reducer, combineReducers } from "redux";

import error from "./statics/error";
import loading from "./statics/loading";
import upload from "./statics/upload";
import user from "./statics/user";

export interface InjectedReducers {
  [key: string]: Reducer;
}

export function createReducer(injectedReducers?: InjectedReducers) {
  return combineReducers({
    error,
    loading,
    upload,
    user,
    ...injectedReducers,
  });
}
